const regionLabelMap = new Map([
  ['state', ['US']],
  ['province', ['CA']]
]);

const postalCodeLabelMap = new Map([['ZIP', ['US']]]);

export function resolveRegionLabel(countryId) {
  for (const [key, value] of regionLabelMap) {
    if (value.includes(countryId)) {
      return key;
    }
  }
  return 'region';
}

export function resolvePostalCodeLabel(countryId) {
  for (const [key, value] of postalCodeLabelMap) {
    if (value.includes(countryId)) {
      return key;
    }
  }
  return 'Postal Code';
}
